import axios from "axios";
import {BaseResponse} from "../BaseResponse";
import {PurchaseRequest} from "./postPurchase";

export async function updatePurchase(uid : string, data : PurchaseRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/purchase/${uid}`, data)

    return response.data
}